import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const societyUpdate = createAsyncThunk("societyUpdate", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.post(`${API_KEY}/api/society/update`, data, {
      headers: { Authorization: `Barear ${token}`},
      "Content-Type": "application/json",
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  societyUpdateData: null,
  isError: false,
  errorMessage: "",
};
const societyUpdateSlice = createSlice({
  name: "societyUpdate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyUpdate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyUpdateData = action.payload;
    });
    builder.addCase(societyUpdate.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyUpdateSlice.reducer;